import { render } from "./OfferPage.vue?vue&type=template&id=78e815d2"
import script from "./OfferPage.vue?vue&type=script&lang=js"
export * from "./OfferPage.vue?vue&type=script&lang=js"

import "./OfferPage.vue?vue&type=style&index=0&id=78e815d2&lang=css"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__